import styled from "@emotion/styled";

import { MDSIcon, MDSIconKind, MDSTextVariant } from "@/mds";
import { useAppStore } from "@/store";

export enum AgentSurfaceNavigationActiveTab {
  Projects = "projects",
  Tasks = "tasks",
}

export const AgentSurfaceNavigation = ({
  activeTab,
}: {
  activeTab: AgentSurfaceNavigationActiveTab;
}) => {
  const { store } = useAppStore();

  return (
    <StyledSurfaceTabs aria-label="Agent pages">
      <StyledSurfaceTab
        type="button"
        $active={activeTab === AgentSurfaceNavigationActiveTab.Projects}
        onClick={() => {
          store.agentOverlay.openProjects();
        }}
      >
        <MDSIcon kind={MDSIconKind.Folder} size={14} />
        <span>Projects</span>
      </StyledSurfaceTab>
      <StyledSurfaceTab
        type="button"
        $active={activeTab === AgentSurfaceNavigationActiveTab.Tasks}
        onClick={() => {
          store.agentOverlay.openTasks();
        }}
      >
        <MDSIcon kind={MDSIconKind.ListCheck} size={14} />
        <span>Tasks</span>
      </StyledSurfaceTab>
    </StyledSurfaceTabs>
  );
};

const StyledSurfaceTabs = styled.nav`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing[2]};
`;

const StyledSurfaceTab = styled.button<{ $active?: boolean }>`
  align-items: center;
  background: ${({ $active, theme }) =>
    $active ? theme.colors.background.input.chrome.default : "transparent"};
  border: 1px solid
    ${({ $active, theme }) => ($active ? theme.colors.border.default : "transparent")};
  border-radius: 999px;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextS]};
  gap: ${({ theme }) => theme.spacing[1]};
  height: 32px;
  padding: 0 ${({ theme }) => theme.spacing[3]};
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.colors.background.input.chrome.hover};
  }
`;
